import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { AccountPage } from "./account/AccountPage";
import { APIProvider } from "./api/APIProvider";
import { AvatarEditorPage } from "./avatar/AvatarEditorPage";
import { AwardPage } from "./award/AwardPage";
import "./index.css";
import { LeaderboardPage } from "./leaderboard/LeaderboardPage";
import { LoginPage } from "./login/LoginPage";
import { NotificationsPage } from "./notifications/NotificationsPage";
import { PeoplePage } from "./people/PeoplePage";
import { RegisterPage } from "./register/RegisterPage";
import { SettingsPage } from "./settings/SettingsPage";
import { TeamCreatePage } from "./team/TeamCreatePage";
import { TeamEditPage } from "./team/TeamEditPage";
import { TeamPage } from "./team/TeamPage";
import { AuthGuard } from "./utils/AuthGuard";
import { initialiseMaxHeight } from "./utils/initialiseMaxHeight";
import { RedirectIfLoggedIn } from "./utils/RedirectIfLoggedIn";
import { YouthKidCreatePage } from "./youth-kid/YouthKidCreatePage";
import { YouthKidEditPage } from "./youth-kid/YouthKidEditPage";
import { YouthKidPage } from "./youth-kid/YouthKidPage";
import { PrivacyPage } from "./privacy/PrivacyPage";
import { SchedulePage } from "./schedule/SchedulePage";
import { AppRoot } from "./app-root/AppRoot";
import { StoreProvider } from "./store/StoreProvider";
import { ActivityPage } from "./schedule/ActivityPage";

initialiseMaxHeight();

const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <RedirectIfLoggedIn>
        <LoginPage />
      </RedirectIfLoggedIn>
    ),
  },
  {
    path: "/register",
    element: (
      <RedirectIfLoggedIn>
        <RegisterPage />
      </RedirectIfLoggedIn>
    ),
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/account/:accountId",
    element: (
      <AuthGuard>
        <AccountPage />
      </AuthGuard>
    ),
  },
  {
    path: "/leaderboard",
    element: (
      <AuthGuard>
        <LeaderboardPage />
      </AuthGuard>
    ),
  },
  {
    path: "/people",
    element: (
      <AuthGuard>
        <PeoplePage />
      </AuthGuard>
    ),
  },
  {
    path: "/award",
    element: (
      <AuthGuard>
        <AwardPage />
      </AuthGuard>
    ),
  },
  {
    path: "/notifications",
    element: (
      <AuthGuard>
        <NotificationsPage />
      </AuthGuard>
    ),
  },
  {
    path: "/settings",
    element: (
      <AuthGuard>
        <SettingsPage />
      </AuthGuard>
    ),
  },
  {
    path: "/team/:teamId",
    element: (
      <AuthGuard>
        <TeamPage />
      </AuthGuard>
    ),
  },
  {
    path: "/team/new",
    element: (
      <AuthGuard>
        <TeamCreatePage />
      </AuthGuard>
    ),
  },
  {
    path: "/team/:teamId/edit",
    element: (
      <AuthGuard>
        <TeamEditPage />
      </AuthGuard>
    ),
  },
  {
    path: "/youth-kid/:youthKidId",
    element: (
      <AuthGuard>
        <YouthKidPage />
      </AuthGuard>
    ),
  },
  {
    path: "/youth-kid/:youthKidId/edit",
    element: (
      <AuthGuard>
        <YouthKidEditPage />
      </AuthGuard>
    ),
  },
  {
    path: "/youth-kid/new",
    element: (
      <AuthGuard>
        <YouthKidCreatePage />
      </AuthGuard>
    ),
  },
  {
    path: "/avatar",
    element: (
      <AuthGuard>
        <AvatarEditorPage />
      </AuthGuard>
    ),
  },
  {
    path: "/schedule",
    element: (
      <AuthGuard>
        <SchedulePage />
      </AuthGuard>
    ),
  },
  {
    path: "/activity/:activityId",
    element: (
      <AuthGuard>
        <ActivityPage />
      </AuthGuard>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <APIProvider>
      <StoreProvider>
        <AppRoot>
          <ChakraProvider>
            <RouterProvider router={router} />
          </ChakraProvider>
        </AppRoot>
      </StoreProvider>
    </APIProvider>
  </React.StrictMode>
);
